import React, { useState } from "react";
import { Ptag } from "components/core";
import { GradeAttributeDetailWrapper } from "./styles";
import GradeAttributeCard from "./GradeAttributeCard";
import RenderList from "./AttributeRenders/RenderList";
import RenderDefault from "./AttributeRenders/RenderDefault";
import AttributeMaternity from "./AttributeRenders/AttributeMaternity";
import AttributeRoomRent from "./AttributeRenders/AttributeRoomRent";
import RoomRentDropdown from "./AttributeRenders/RoomRentDropdown";
import StarSvg from "../../../assets/svgs2026/starIconSvg.svg"


function GradeAttributeDetail({ attribute }) {
  const [selectionHandler, setSelectionHandler] = useState("metro")
  const [roomRentSelectionHandler, setRoomRentSelectionHandler] = useState("metro")

  const displayRoomRentLimitToggle = () => {
    let attributeName = attribute?.name
    let attributeIsNotDefault = attribute?.data?.type !== "DEFAULT"
    if(attribute && attributeName === "Room Rent Limit" && attributeIsNotDefault) {
      return true
    }
    return false
  } 

  const displayMaternityCoverageToggle = () => {
    let attributeName = attribute?.name
    let attributeIsNotDefault = attribute?.data?.type !== "DEFAULT"
    if(attribute && attributeName === "Maternity Coverage" && attributeIsNotDefault) {
      return true
    }
    return false
  } 

  return (
    <GradeAttributeDetailWrapper>
      <header>
        {/* <img src={attribute?.icon} alt="" /> */}
        <div style={{ width: "100%"}}>
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between"}}>
            
            <div style={{ display: "flex", width: "100%", alignItems: "center", gap: "5px" }}>
              <div style={{ width: "fit-content", whiteSpace: "nowrap"}}>
              <Ptag fontWeight="400" fontSize="28px" color="rgba(46, 7, 64, 1)" fontFamily="Instrument Serif" lineHeight="20px">
                {attribute?.display_name}
              </Ptag>
              </div>
              <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                <img src={StarSvg} alt="StarSvg" />
                <div className="starLineCss" style={{ width: "100%" }} />
              </div>
            </div>

            {attribute?.display_name === "Maternity Coverage" && displayMaternityCoverageToggle() &&
            <RoomRentDropdown selectionHandler={selectionHandler} setSelectionHandler={setSelectionHandler} />
            }
            {attribute?.display_name === "Room Rent Limit" && displayRoomRentLimitToggle() &&
            <RoomRentDropdown selectionHandler={roomRentSelectionHandler} setSelectionHandler={setRoomRentSelectionHandler} />
            }
          </div>
          {/* <Ptag
            fontWeight="400"
            fontSize="14px"
            marginTop="6px"
            color="#585858"
          >
            {attribute?.description}
          </Ptag> */}
        </div>
      </header>
      <section>
        {(() => {
          // Check if all values are null
          const hasNullValues = attribute?.data?.values &&  
            Object.values(attribute.data.values).every(value => 
              value === null || value === undefined || value === ""
            );
          
          if (hasNullValues) {
            return (
              <Ptag fontSize="14px" color="#999">
                null
              </Ptag>
            );
          }
          
          if (attribute?.name === "Maternity Coverage") {
            return <AttributeMaternity data={attribute?.data} selectionHandler={selectionHandler} />;
          } else if (attribute?.name === "Room Rent Limit") {
            return <AttributeRoomRent data={attribute?.data} selectionHandler={roomRentSelectionHandler} />;
          } else if (attribute?.data?.type === "LIST") {
            return <RenderList list={attribute?.data?.values} />;
          } else if (attribute?.data?.type === "DEFAULT") {
            return <RenderDefault data={attribute?.data?.values} />;
          } else {
            return null; // Optional: handle cases where no condition is met
          }
        })()}
      </section>
    </GradeAttributeDetailWrapper>
  );
}

export default GradeAttributeDetail;
